/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiOffIcon20Light = forwardRef('NetConnectWifiOffIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.854 2.146a.5.5 0 1 0-.708.708l2.896 2.895A11 11 0 0 0 1.86 7.597a.5.5 0 0 0 .74.673 10 10 0 0 1 2.167-1.796l2.967 2.967a6.004 6.004 0 0 0-2.345 1.716.5.5 0 0 0 .768.64 5 5 0 0 1 2.358-1.575l7.131 7.132a.5.5 0 0 0 .708-.708l-14.5-14.5Z" }),
        React.createElement("path", { d: "m10.699 9.037 1.439 1.44a5 5 0 0 1 1.704 1.32.5.5 0 0 0 .769-.64 6 6 0 0 0-3.912-2.12Z" }),
        React.createElement("path", { d: "m6.3 4.637.79.792A10 10 0 0 1 17.4 8.27a.5.5 0 1 0 .74-.672A11 11 0 0 0 6.3 4.638Z" }),
        React.createElement("path", { d: "M10.707 15.703a1 1 0 1 0-1.414-1.414 1 1 0 0 0 1.414 1.414Z" })));
});
